module.exports = __webpack_public_path__ + "img/SVG7_CoverEstimate.f692cb20.svg";